// src/components/MySlider.js
import React, { useEffect } from 'react';
import $ from 'jquery';
import 'slick-carousel/slick/slick.min.js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './MySlider.css'; // 追加
import applyImage from '../images/parti_image.jpg';
import detailImage from '../images/detail_image.jpg';
import schduleImage from '../images/shchedule_image.jpg';
import movieImage from '../images/movie_image.jpg';
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出

const MySliderPC = () => {
    useEffect(() => {
      $('.slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20px', // 画像間の距離を調整
        autoplay: true, // 自動再生を有効にする
        autoplaySpeed: 2000, // 自動再生の速度 (ミリ秒)
        prevArrow: '<button class="slick-prev">←</button>',
        nextArrow: '<button class="slick-next">→</button>',
      });
    }, []);

  return (
    <div className="slider">
      <div><a href="/apply"><img src={applyImage} alt="Image 1" /></a></div>
      <div><a href="/detail"><img src={detailImage} alt="Image 2" /></a></div>
      <div><a href="/schedule"><img src={schduleImage} alt="Image 3" /></a></div>
      <div><a href="/"><img src={movieImage} alt="Image 4" /></a></div>
    </div>
  );
}

const MySliderMobile = () => {
  useEffect(() => {
    $('.mobileslider').slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,  // 1枚ずつ表示
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0px', // センターモードで余白をなくす
      autoplay: true, // 自動再生を有効にする
      autoplaySpeed: 1500, // 自動再生の速度 (ミリ秒)
      prevArrow: '<button class="slick-prev">←</button>',
      nextArrow: '<button class="slick-next">→</button>',
    });
  }, []);

  return (
    <div className="mobileslider">
      <div><a href="/apply"><img src={applyImage} alt="Image 1" /></a></div>
      <div><a href="/detail"><img src={detailImage} alt="Image 2" /></a></div>
      <div><a href="/schedule"><img src={schduleImage} alt="Image 3" /></a></div>
      <div><a href="/"><img src={movieImage} alt="Image 4" /></a></div>
    </div>
  );
}

function MySlider() {
  return isMobile ? <MySliderMobile /> : <MySliderPC />;
}

export default MySlider;
